import useTranslation from '@/utils/hooks/translation/useTranslation';

const ErrorAnalyticsFallback = ({ resetErrorBoundary }: { resetErrorBoundary: () => void }) => {
    const { t } = useTranslation();
    return (
        <div
            role="alert"
            className="col-span-full flex h-full w-full flex-1 flex-col items-center justify-center space-y-3 rounded bg-white p-8 dark:bg-icoDarkMode-anthracite"
            data-testid="error-boundary">
            <p className="text-center">{t('errors:error_occured_fetch_data')} </p>
            <button className="text-icoBlue underline" onClick={resetErrorBoundary}>
                {t('commons:try_again')}
            </button>
        </div>
    );
};

export default ErrorAnalyticsFallback;
